const contact = {
    init() {
        $('.multiple-select').multipleSelect();
    },
};

export default contact;
